var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "12px",
    viewBox: "0 0 4 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-planningList-actions-delaySuccessConfirm-tags",
    transform: "translate(-897.000000, -478.000000)",
    fill: "#959595",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(200.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(547.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(147.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-more",
    transform: "translate(5.000000, 1.100000) rotate(-90.000000) translate(-5.000000, -1.100000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08695652,-0.22 C0.366532301,-0.22 -0.217391304,0.370930688 -0.217391304,1.1 C-0.217391304,1.82906931 0.366532301,2.42 1.08695652,2.42 C1.80738074,2.42 2.39130435,1.82906931 2.39130435,1.1 C2.39130435,0.370930688 1.80738074,-0.22 1.08695652,-0.22 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,-0.22 C4.27957578,-0.22 3.69565217,0.370930688 3.69565217,1.1 C3.69565217,1.82906931 4.27957578,2.42 5,2.42 C5.72042422,2.42 6.30434783,1.82906931 6.30434783,1.1 C6.30434783,0.370930688 5.72042422,-0.22 5,-0.22 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91304348,-0.22 C8.19261926,-0.22 7.60869565,0.370930688 7.60869565,1.1 C7.60869565,1.82906931 8.19261926,2.42 8.91304348,2.42 C9.6334677,2.42 10.2173913,1.82906931 10.2173913,1.1 C10.2173913,0.370930688 9.6334677,-0.22 8.91304348,-0.22 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic-more.54975a30811064884b78af09b90485a4.svg";
export { ForwardRef as ReactComponent };